import React from 'react';

const LeafDivider = ({ fromColor = "white", toColor = "pink-50", flip = false }) => {
  const getTailwindColor = (color) => {
    const colorMap = {
      'white': '#ffffff',
      'champagne': '#F7E7CE',
      'sand': '#E6D5AC',
      'beige': '#F5E6CC',
      'ivory': '#FFFFF0',
      'wheat': '#F5DEB3',
      'pearl': '#EAE0C8',
      'gold': '#D4AF37',
      'cream': '#FFEFD5'
    };
    const cleanColor = color.replace('bg-', '');
    return colorMap[cleanColor] || color;
  };

  return (
    <div className="w-full relative z-10 -mb-16">
      <svg
        className={`w-full h-24 ${flip ? 'transform rotate-180' : ''}`}
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
        style={{
          fill: getTailwindColor(toColor),
          backgroundColor: getTailwindColor(fromColor)
        }}
      >
        {/* Patrón base gótico */}
        <path d="M0,0 
          C50,20 100,0 150,20 
          C200,40 250,0 300,20 
          C350,40 400,0 450,20 
          C500,40 550,0 600,20 
          C650,40 700,0 750,20 
          C800,40 850,0 900,20 
          C950,40 1000,0 1050,20 
          C1100,40 1150,0 1200,20 
          L1200,120 L0,120 Z"
        />

        {/* Detalles ornamentales góticos */}
        <path d="M0,30 
          C25,40 50,30 75,40 
          C100,50 125,30 150,40"
          fill="none"
          stroke={getTailwindColor(toColor)}
          strokeWidth="1"
          opacity="0.3"
          className="gothic-detail"
        />

        {/* Patrón repetido a lo largo */}
        {[...Array(8)].map((_, i) => (
          <path
            key={i}
            d={`M${i * 150},30 
              C${i * 150 + 25},40 ${i * 150 + 50},30 ${i * 150 + 75},40 
              C${i * 150 + 100},50 ${i * 150 + 125},30 ${i * 150 + 150},40`}
            fill="none"
            stroke={getTailwindColor(toColor)}
            strokeWidth="1"
            opacity="0.3"
            className="gothic-detail"
          />
        ))}

        {/* Arcos góticos decorativos */}
        <path
          d="M0,60 
            C100,90 200,60 300,90 
            C400,120 500,60 600,90 
            C700,120 800,60 900,90 
            C1000,120 1100,60 1200,90"
          fill="none"
          stroke={getTailwindColor(toColor)}
          strokeWidth="1.5"
          opacity="0.4"
        />
      </svg>
    </div>
  );
};

export default LeafDivider; 